import { ColDef } from 'ag-grid-community';

import { Volume } from '~/shared/types/api';
import Typography from '~/shared/components/Typography';
import Table from '~/shared/components/Table';
import Tag from '~/shared/components/Tag';
import Tooltip from '~/shared/components/Tooltip';

interface VolumeTagsTableProps {
  volume: Volume;
}

type VolumeTag = {
  key: string;
  value: string;
};

export default function VolumeTagsTable({ volume }: VolumeTagsTableProps) {
  const tags = volume.tags || [];

  // Debug: Check if we have tags
  // console.log('VolumeTagsTable - tags:', tags, 'length:', tags.length);

  if (!tags || tags.length === 0) {
    return (
      <div className="h-96 flex flex-1 items-center justify-center py-8 ">
        <div className="mt-3.5 flex items-center justify-center py-8">
          <Typography variant="p3" color="text-gray-500">
            No Results
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-[360px] lg:h-[376px] w-ful mt-3 pb-8 2xl:pb-7.5 3xl:pb-6.5 [&_.ag-root-wrapper]:!border-0 [&_.ag-root-wrapper]:!rounded-none [&_.ag-row-last]:!border-b-0">
      <Table
        columnDefs={columnDefs}
        rowData={tags}
        headerHeight={48}
        disableClientSort
        itemsName="tags"
      />
    </div>
  );
}

const columnDefs: ColDef<VolumeTag>[] = [
  {
    headerName: 'Key',
    field: 'key',
    flex: 1,
    minWidth: 140,
    cellRenderer: ({ value }: { value: string }) => {
      if (!value) {
        return 'N/A';
      }

      // const displayValue = value.length > 19 ? `${value.substring(0, 19)}...` : value;

      return (
        <>
          <span className="text-ellipsis overflow-hidden" data-tooltip-id={`key-${value}`}>
            {value}
          </span>
          <Tooltip id={`key-${value}`} content={value} />
        </>
      );
    },
  },
  {
    headerName: 'Value',
    field: 'value',
    flex: 2,
    minWidth: 280,
    // initialWidth: 320,
    cellRenderer: ({ value }: { value: string }) => {
      if (!value) {
        return 'N/A';
      }
      return (
        <>
          <Tag
            size="sm"
            text={value}
            variant="volume"
            showFullText={true}
            dataTooltipId={`volume-${value}`}
          />
          <Tooltip id={`volume-${value}`} content={value} />
        </>
      );
    },
  },
];
